import { AddressbarColor, colors } from 'quasar'
const { getPaletteColor } = colors

export default () => {
  AddressbarColor.set(getPaletteColor('primary'))
}
